var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeerat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.176,
    height: 235.197,
    viewBox: "0 0 223.176 235.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7968",
    "data-name": "Group 7968",
    transform: "translate(-267.459 -409.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39312",
    "data-name": "Path 39312",
    d: "M423.65,555.949V541.927l-4.365-4.369V521.51l-5.188-5.188h-1.083s13.247-45.728-52.973-79.15l-8.509-8.509h.2l-8.5,8.509c-66.224,33.421-52.977,79.15-52.977,79.15l-5.188,5.188v16.048l-4.365,4.369v14.022Z",
    transform: "translate(44.088 64.652)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39313",
    "data-name": "Path 39313",
    d: "M311.952,437.171l-8.308-8.507-8.507,8.507Z",
    transform: "translate(92.177 64.653)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39314",
    "data-name": "Path 39314",
    d: "M281.966,468.163v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(48.315 152.256)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39315",
    "data-name": "Path 39315",
    d: "M318.566,480.4V462.913l-4.856-4.856",
    transform: "translate(154.03 162.542)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39316",
    "data-name": "Path 39316",
    d: "M284.418,458.057l-4.856,4.856V480.4",
    transform: "translate(40.308 162.542)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39317",
    "data-name": "Path 39317",
    d: "M280.7,555.949V541.927l4.365-4.369V521.51l5.188-5.188S277,470.594,343.227,437.172l8.5-8.509,8.31,8.509c66.219,33.421,52.977,79.15,52.977,79.15H414.1l5.188,5.188v16.048l4.365,4.369v14.022Z",
    transform: "translate(44.088 64.652)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1640",
    "data-name": "Line 1640",
    y1: 16.99,
    transform: "translate(395.82 476.327)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1641",
    "data-name": "Line 1641",
    x1: 16.815,
    transform: "translate(387.313 501.824)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1642",
    "data-name": "Line 1642",
    x2: 122.768,
    transform: "translate(334.337 580.975)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1643",
    "data-name": "Line 1643",
    x2: 134.219,
    transform: "translate(329.152 602.209)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39318",
    "data-name": "Path 39318",
    d: "M284.585,463.782v-8a5.194,5.194,0,0,1,10.389,0v8",
    transform: "translate(57.037 137.666)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39319",
    "data-name": "Path 39319",
    d: "M290.232,463.782v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(75.843 137.666)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39320",
    "data-name": "Path 39320",
    d: "M295.88,463.782v-8a5.192,5.192,0,0,1,10.384,0v8",
    transform: "translate(94.653 137.666)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39321",
    "data-name": "Path 39321",
    d: "M301.527,463.782v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(113.459 137.666)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39322",
    "data-name": "Path 39322",
    d: "M307.174,463.782v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(132.265 137.666)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39323",
    "data-name": "Path 39323",
    d: "M287.613,468.163v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(67.121 152.256)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39324",
    "data-name": "Path 39324",
    d: "M293.26,468.163v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(85.927 152.256)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39325",
    "data-name": "Path 39325",
    d: "M298.907,468.163v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(104.734 152.256)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39326",
    "data-name": "Path 39326",
    d: "M304.555,468.163v-8a5.192,5.192,0,1,1,10.384,0v8",
    transform: "translate(123.543 152.256)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39327",
    "data-name": "Path 39327",
    d: "M309.779,468.163v-8a5.194,5.194,0,0,1,10.388,0v8",
    transform: "translate(140.941 152.256)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1644",
    "data-name": "Line 1644",
    x2: 223.176,
    transform: "translate(267.459 642.946)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39328",
    "data-name": "Path 39328",
    d: "M273.995,629.88V521.34l-3.391-15.8h6.158V461.482l-2.694-15.75h6.34v-15.36h1.217l8.089-17.2h5.006l8.206,17.2h.836v15.36h6.34l-2.694,15.823v43.987h6.145l-4.174,15.8v97.255l.065,11.428m-35.448-.143V521.34l-3.391-15.8h6.158V461.482l-2.694-15.75h6.34v-15.36h1.217l8.089-17.2h5.006l8.206,17.2h.836v15.36h6.34l-2.694,15.823v43.987h6.145l-4.174,15.8v97.255l.065,11.428",
    transform: "translate(10.475 13.065)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1645",
    "data-name": "Line 1645",
    x2: 23.354,
    transform: "translate(290.883 443.436)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1646",
    "data-name": "Line 1646",
    x2: 23.354,
    transform: "translate(290.883 458.796)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1647",
    "data-name": "Line 1647",
    x2: 30.643,
    transform: "translate(287.239 518.606)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1648",
    "data-name": "Line 1648",
    x2: 35.382,
    transform: "translate(284.469 534.404)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1649",
    "data-name": "Line 1649",
    y1: 16.99,
    transform: "translate(302.677 409.25)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39329",
    "data-name": "Path 39329",
    d: "M306.859,448.759l-5.912-4.273-5.912,4.273-5.912-4.273-5.912,4.273-5.912-4.273-5.912,4.273",
    transform: "translate(13.083 117.348)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39330",
    "data-name": "Path 39330",
    d: "M271.387,451.828l5.912-4.273,5.912,4.273",
    transform: "translate(13.083 127.567)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39331",
    "data-name": "Path 39331",
    d: "M274.117,451.828l5.912-4.273,5.913,4.273",
    transform: "translate(22.176 127.567)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39332",
    "data-name": "Path 39332",
    d: "M276.848,451.828l5.912-4.273,5.912,4.273",
    transform: "translate(31.27 127.567)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39333",
    "data-name": "Path 39333",
    d: "M271.387,454.9l5.912-4.273,5.912,4.273",
    transform: "translate(13.083 137.786)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39334",
    "data-name": "Path 39334",
    d: "M274.117,454.9l5.912-4.273,5.913,4.273",
    transform: "translate(22.176 137.786)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39335",
    "data-name": "Path 39335",
    d: "M276.848,454.9l5.912-4.273,5.912,4.273",
    transform: "translate(31.27 137.786)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39336",
    "data-name": "Path 39336",
    d: "M271.387,457.964l5.912-4.273,5.912,4.273",
    transform: "translate(13.083 148.004)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39337",
    "data-name": "Path 39337",
    d: "M274.117,457.964l5.912-4.273,5.913,4.273",
    transform: "translate(22.176 148.004)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39338",
    "data-name": "Path 39338",
    d: "M276.848,457.964l5.912-4.273,5.912,4.273",
    transform: "translate(31.27 148.004)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39339",
    "data-name": "Path 39339",
    d: "M306.859,461.033l-5.912-4.273-5.912,4.273-5.912-4.273-5.912,4.273L277.3,456.76l-5.912,4.273",
    transform: "translate(13.083 158.223)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1650",
    "data-name": "Line 1650",
    x2: 30.643,
    transform: "translate(287.239 474.545)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1651",
    "data-name": "Line 1651",
    y2: 3.39,
    transform: "translate(281.081 515.216)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1652",
    "data-name": "Line 1652",
    y1: 3.39,
    transform: "translate(324.029 515.216)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeerat);
export default __webpack_public_path__ + "static/media/Seerat.a9de211279b5bafeccbf2b34917db36d.svg";
export { ForwardRef as ReactComponent };